import _Object$keys from 'babel-runtime/core-js/object/keys';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { format } from 'date-fns';
import { parseCategory } from '@/filters';
import SearchBar from '@/components/SearchV3';
import Pagination from '@/components/Pagination';
import TableList from '@/components/TableList';
import CreativeDirectionDialog from '@/components/CreativeDirectionDialog';
import searchMixin from '@/mixin/search';
import { fetchCreativeInfoList } from '@/api/creative/info';
import { getInteractiveTagList } from '@/api/system/interactive-tag.js';
import ExportXlsx from '@/components/ExportXlsxBtn';

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    CreativeDirectionDialog: CreativeDirectionDialog,
    ExportXlsx: ExportXlsx
  },

  mixins: [searchMixin],

  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        search_field: 'id',
        keyword: ''
      },

      pagination: {
        total: 0
      },

      formItemList: [{
        type: 'business',
        subtype: 'creative-direction-selector',
        prop: 'keyword',
        params: {
          clearable: true
        }
      }],

      list: [],
      listLoading: true,

      sheetTitle: '创意方向列表报表',
      sheetHeader: {},
      sheetBody: [],

      tableConfig: {},
      tableColumnConfig: [{
        label: '序号',
        prop: 'id',
        width: 90
      }, {
        label: '创意方向',
        prop: 'name',
        type: 'link',
        params: {
          link: function link(_ref) {
            var row = _ref.row;

            return '/butler/creative-direction-management?search_field=id&keyword=' + row.id;
          }
        }
      }, {
        label: '创意类型',
        prop: 'material_type'
      }, {
        label: '特征标签',
        prop: 'tag_names',
        slot: 'tag_names-cell'
      }, {
        label: '更新时间',
        prop: 'updated_time'
      }, {
        slot: 'action-cell'
      }],

      dialog: {
        config: {
          loading: false,
          title: '',
          visible: false
        },
        value: {
          id: '',
          name: '',
          app_id: '',
          material_type: '',
          enable_i18n: ''
        }
      }
    };
  },


  computed: {},

  watch: {
    $route: function $route(to, from) {
      this.getCreativeInfoList(this.query);
    }
  },

  mounted: function mounted() {
    this.getCreativeInfoList(this.query);
    this.getSheetHeader();
  },


  methods: {
    request: function request(params) {
      return fetchCreativeInfoList(_extends({}, this.query, params));
    },
    getCreativeInfoList: function getCreativeInfoList(params) {
      var _this = this;

      this.listLoading = true;

      fetchCreativeInfoList(params).then(function (res) {
        _this.listLoading = false;
        _this.list = _this.cookList(_.get(res, 'data.data.list') || []);
        _this.cookSheetList(res);
        _this.pagination.total = _.get(res, 'data.data.total');
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    getSheetHeader: function getSheetHeader() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var headers, res, tags;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                headers = {};

                _this2.tableColumnConfig.forEach(function (item) {
                  if (item.prop) headers[item.prop] = item.label;
                });
                _context.next = 4;
                return getInteractiveTagList();

              case 4:
                res = _context.sent;
                tags = _.get(res, 'data.data.tag.sub_tags');

                tags.forEach(function (item) {
                  headers[item.name] = item.name;
                });
                _this2.sheetHeader = _extends({}, headers);
                console.log(_this2.sheetHeader);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    cookSheetList: function cookSheetList(res) {
      var list = this.cookList(res);

      return list.map(function (item, index) {
        var tags = _Object$keys(item.tag_names).map(function (key) {
          return {
            key: key,
            value: item.tag_names[key]
          };
        }).reduce(function (accumulator, currentValue) {
          return accumulator + currentValue.key + '：' + currentValue.value + '\n';
        }, '');

        return _extends({}, item, {
          tag_names: tags
        }, item.tag_names);
      });
    },
    cookList: function cookList(res) {
      var list = [];

      if (!Array.isArray(res)) {
        list = _.get(res, 'data.data.list') || [];
      } else {
        list = res;
      }

      return list.map(function (item) {
        return _extends({}, item, {
          updated_time: format(item.updated_time * 1000, 'YYYY-MM-DD HH:mm:ss'),
          material_type: parseCategory(item.material_type),
          tag_names: item.tag_names ? JSON.parse(item.tag_names) : ''
        });
      });
    },
    showDialog: function showDialog(data) {
      this.dialog.config.visible = true;
      if (data.type === 'update') {
        this.dialog.config.title = '编辑创意方向';
        this.dialog.value.id = data.data.id;
        this.dialog.value.name = data.data.name;
        this.dialog.value.material_type = data.data.material_type;
        this.dialog.value.enable_i18n = data.data.enable_i18n;
      } else {
        this.dialog.config.title = '添加创意方向';
        this.dialog.value.id = '';
        this.dialog.value.name = '';
        this.dialog.value.app_id = '';
        this.dialog.value.material_type = '';
        this.dialog.value.enable_i18n = '';
      }
    },
    operateSuccess: function operateSuccess() {
      this.getCreativeInfoList(this.query);
    }
  }
};